export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_KEY;
export const BASE_URL =
  process.env.REACT_APP_API_URL || "https://backend.golfbert.com";

/**
 * How long a rotated API key keeps working before it stops.
 *
 * Rotation is deliberately NOT instantly destructive, which deviates from
 * golfbert-static#49 — the issue text said rotation "revokes old keys
 * immediately". It does not: the backend writes prev_expires_at at
 * rotationOverlapDays (services/provisioning/config.js, default 7) and a
 * sweeper retires the old credential after that.
 *
 * This number is customer-facing in four places — the rotate confirmation, the
 * API Access panel, the FAQ and the Authentication guide — so it lives here
 * rather than in any one of them. Keep it in step with the backend's
 * rotationOverlapDays; the two are separate values today and can drift.
 */
export const GRACE_WINDOW_DAYS = 7;
